"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("../type");
var utils_1 = require("../helper/utils");
function getType(type) {
    // type now support either 'string' or String
    var typeName = '';
    var options = {};
    if (utils_1.isArray(type)) {
        typeName = 'array';
        var arrayOf = type[0].name ?
            type[0].name.toLowerCase && type[0].name.toLowerCase() :
            type[0].toLowerCase && type[0].toLowerCase();
        if (type_1.supportType[utils_1.captitalize(arrayOf)]) {
            options.arrayOf = utils_1.captitalize(arrayOf);
        }
        else {
            throw new Error("Kya: " + (utils_1.captitalize(typeName) || type) + " is not supported.");
        }
    }
    else if (utils_1.isObject(type)) {
        typeName = 'object';
        var objectKeys = Object.keys(type);
        if (objectKeys.length > 0) {
            options.objectOf = type;
        }
    }
    else {
        // should look after it to resolve no name or toLowerCase issue.
        // @ts-ignore
        typeName = type.name ? type.name.toLowerCase && type.name.toLowerCase() : type.toLowerCase && type.toLowerCase();
    }
    if (type_1.supportType[utils_1.captitalize(typeName)]) {
        return [typeName, options];
    }
    else {
        throw new Error("Kya: " + (utils_1.captitalize(typeName) || type) + " is not supported.");
    }
}
exports.default = getType;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/helper/getType.js
// module id = 63
// module chunks = 0